"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingModal = void 0;
const React = __importStar(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const react_spinners_1 = require("react-spinners");
const react_modal_utilities_1 = require("./shared/react-modal-utilities");
const z_index_1 = require("../z-index");
function LoadingModal({ Show, Message, Dimensions = { Width: 500 }, OverlayStyle, ContentStyle }) {
    const contentStyle = Object.assign(Object.assign({}, react_modal_utilities_1.verticalCenterStyle), ContentStyle || {});
    const overlayStyle = Object.assign({
        zIndex: z_index_1.modalZIndex
    }, OverlayStyle || {});
    return React.createElement(react_modal_1.default, { isOpen: Show, style: {
            content: Object.assign(Object.assign({}, contentStyle), { width: `${Dimensions.Width}px`, height: typeof Dimensions.Height === "number" ? `${Dimensions.Height}px` : "SizeToContent", padding: 0 }),
            overlay: overlayStyle
        }, ariaHideApp: false },
        React.createElement("div", { className: "modal-body", style: { alignContent: "center" } },
            React.createElement("div", null,
                React.createElement("p", null, Message)),
            React.createElement("div", { style: { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", marginTop: "1em" } },
                React.createElement(react_spinners_1.ClipLoader, { color: "#000000" }))));
}
exports.LoadingModal = LoadingModal;
//# sourceMappingURL=loading-modal.js.map